import { FaEye } from 'react-icons/fa';

const IconView = FaEye;

export default IconView;
